export const setNodes = (nodes) => {
    return {
        type: "SET_NODES",
        nodes
    }
}

export const setExecuting = (isExecuting) => ({
    type: "SET_EXECUTING",
    isExecuting
});
